import icons from './icons.json'
import { dialogLabelOption } from './miniComprehensive'

export const comprehensive_auto: BenefitStoreContext[string] = {
	product_title: 'Protect your work vehicles from all kinds of damages',
	short_description: 'Protect yourself and your vehicles from all kinds of damages for only ₦.',
	description: 'Comprehensive Auto Insurance protects your vehicle at ₦ of its value per year.',
	card_label: 'Coverage for damages, theft, fire, and more. Protection from mcg_price of vehicle value.',
	dialogLabels: dialogLabelOption,
	short_benefits: {
		'Your Business Will Enjoy': {
			icon: icons.business,
			isOpen: false,
			value: [
				'Protection against damage to your vehicles due to accidents or fire.',
				'Compensation in the case of theft of your vehicles.',
				'Unlimited coverage for third-party bodily injuries due to insured vehicles.',
				'Coverage for damage to third-party properties is based on the value of the vehicle insured.',
				'Coverage for car towing, up to ₦20,000.',
				'Free tracker for vehicle above 6 million.'
			]
		},
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'NIID and Validity: Our auto insurance policies are genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and sent to you via email. You can always present the certificate from your email to officials or print it in a hard copy format.'
			]
		},
		'How to Get Covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a comprehensive auto plan.',
				'Submit all necessary information and documents.',
				'Activate your policy with your vehicle details to receive your insurance certificate.',
				'Conduct a pre-loss inspection to be fully covered.'
			]
		},
		'How to Claim': {
			icon: icons.claim,
			isOpen: false,
			value: [
				'Login to your account and go to the claims section.',
				'Report your claim with details of the incident.',
				'Conduct post-loss inspection.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Protection against damage to your vehicles due to accidents or fire.',
				'Compensation in the case of theft of your vehicles.',
				'Unlimited coverage for third-party bodily injuries due to insured vehicles.',
				'Coverage for damage to third-party properties is based on the value of the vehicle insured.',
				'Coverage for car towing, up to ₦20,000.',
				'Free tracker for vehicle above 6 million.'
			],
			need_to_know: [
				'NIID and Validity: Our auto insurance policies are genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and sent to you via email. You can always present the certificate from your email to officials or print it in a hard copy format.'
			],

			'How to Claim': [
				'Login to your account and go to the claims section.',
				'Report your claim with details of the incident.',
				'Conduct post-loss inspection.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	}
}
